module.exports = __webpack_public_path__ + "img/pengalaman.9a4b554b.svg";